import React from 'react';
import PageHeader, { Highlight } from '../components/ui/PageHeader';
import StatWidget from '../components/features/StatWidget';
import FeatureCard from '../components/features/FeatureCard';
import { useAppStore } from '../store/appStore';
import { FEATURE_CARDS } from '../utils/constants';

const DashboardPage: React.FC = () => {
  const { stats } = useAppStore();

  const statWidgets = [
    { value: stats.builds,             label: 'Builds Completed',  change: '+3 this week' },
    { value: stats.lines.toLocaleString(), label: 'Lines of Code',  change: 'Last commit 2h ago', changePositive: true },
    { value: `${stats.apkSize} MB`,    label: 'Latest APK Size',   change: 'Optimized ✓' },
    { value: stats.errors,             label: 'Build Errors',       change: 'All clear ✓',         changePositive: true },
  ];

  return (
    <>
      <PageHeader
        title={<>Welcome to <Highlight>FIN Contra</Highlight></>}
        subtitle="Build, convert & deploy React Native apps to Android — all in one place."
      />

      {/* Stats row */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
          gap: 16,
          marginBottom: 28,
        }}
      >
        {statWidgets.map((s) => (
          <StatWidget key={s.label} {...s} />
        ))}
      </div>

      {/* Feature cards grid */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: 20,
        }}
      >
        {FEATURE_CARDS.map((card) => (
          <FeatureCard key={card.title} {...card} />
        ))}
      </div>
    </>
  );
};

export default DashboardPage;
